export default __webpack_public_path__ + "static/media/mlbbignew.fe6e92e7.png";